/// <reference types="vite/client" />

import './index.css'
import '@eggplant/layout-css/src/lib/styling/card.css'
import '@eggplant/layout-css/src/lib/styling/content.css'
import '@eggplant/layout-css/src/lib/styling/header.css'
import LicenseCheckpoint from './lib/components/Router/GateKeeper/LicenseCheckpoint/LicenseCheckpoint'
import queryString from 'query-string'
import {
  AuthProvider,
  CustomScriptContextProvider,
  DataCollectionProvider,
  DocumentTitleContextProvider,
  ExecutionEnvironmentProvider,
  ModelProvider,
  MonitorConfigProvider,
  PreferencesProvider,
  PreviewFeatureContextProvider,
  RequirementsContextProvider,
  SpaceProvider,
  ThemeConsumer,
  ThemeProvider,
  UpmReportingContextProvider
} from '@eggplant/context'
import { LocationProvider } from '@reach/router'
import { Telemetry } from '@eggplant/telemetry'
import { ThemeWatcher } from '@eggplant/pattern-library'
import { createRoot } from 'react-dom/client'

const props = queryString.parse(window.location.search, { arrayFormat: 'comma' })

const authToken = props.authToken
  ? props.authToken.toString()
  : undefined

const collapsedState = props.collapsedState
  ? props.collapsedState.toString()
  : undefined

const modelId = props.modelId
  ? props.modelId.toString()
  : undefined

const monitorConfigId = props.monitorConfigId
  ? props.monitorConfigId.toString()
  : undefined

const root = createRoot(document.getElementById('root')!)

root.render(
  <LocationProvider>
    <ModelProvider selectedModelId={modelId}>
      <MonitorConfigProvider selectedMonitorConfigId={monitorConfigId}>
        <PreferencesProvider isNavCollapsed={collapsedState === 'true'}>
          <ThemeProvider>
            <ThemeConsumer>
              {
                ({ theme }) =>
                  <ThemeWatcher theme={theme} />
              }
            </ThemeConsumer>
            <AuthProvider
              authToken={authToken}
              isKeycloakOn={import.meta.env.VITE_IS_AUTH_DISABLED !== 'true'}
            >
              <DocumentTitleContextProvider>
                <UpmReportingContextProvider>
                  <CustomScriptContextProvider>
                    <RequirementsContextProvider>
                      <ExecutionEnvironmentProvider>
                        <DataCollectionProvider>
                          <Telemetry>
                            <SpaceProvider>
                              <PreviewFeatureContextProvider>
                                <LicenseCheckpoint />
                              </PreviewFeatureContextProvider>
                            </SpaceProvider>
                          </Telemetry>
                        </DataCollectionProvider>
                      </ExecutionEnvironmentProvider>
                    </RequirementsContextProvider>
                  </CustomScriptContextProvider>
                </UpmReportingContextProvider>
              </DocumentTitleContextProvider>
            </AuthProvider>
          </ThemeProvider>
        </PreferencesProvider>
      </MonitorConfigProvider>
    </ModelProvider>
  </LocationProvider>
)
